import { render } from "./InitialUwLeaderboardCard.vue?vue&type=template&id=09fc5afc&scoped=true"
import script from "./InitialUwLeaderboardCard.vue?vue&type=script&lang=js"
export * from "./InitialUwLeaderboardCard.vue?vue&type=script&lang=js"

import "./InitialUwLeaderboardCard.vue?vue&type=style&index=0&id=09fc5afc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fc5afc"]])

export default __exports__